import {Project} from '../types';

// Mirrors ProjectWriter.CodeMaxLength (and the [StringLength(32)] on
// Project.Code). The server trims and treats blank as "no code".
export const PROJECT_CODE_MAX_LENGTH = 32;

type ProjectLabelSource = Pick<Project, 'name'> & {code?: string | null};

// Text a project picker or search box should match against: the name and,
// when present, the code, so typing "PRJ-042" finds the project.
export const projectSearchText = (project: ProjectLabelSource): string =>
    project.code ? `${project.code} ${project.name}` : project.name;

// "PRJ-042 · Apollo" when a code is present, otherwise just the name.
export const projectDisplayLabel = (project: ProjectLabelSource): string =>
    project.code ? `${project.code} · ${project.name}` : project.name;
